import { UserRole } from "../../common/EmployeeContext";

export enum CoachingStatus {
    NA = 'n/a',
    Required = 'required',
    Complete = 'complete',
}

export enum QualityQuestionValue {
    Yes = 'Yes',
    No = 'No',
    NA = 'N/A',
}

export interface SettingEnvironment {
    api_prefix: string;
    cstools: {
        enableCsqaIntegration: boolean;
    };
}

export interface Settings {
    [key: string]: SettingEnvironment;
    default: SettingEnvironment;
}

export interface CsqaDashboardProps {
    userPermissions: Set<string>;
    user: string;
    role?: UserRole;
    org: string;
}

export interface CsqaIdentifiers {
    evaluatorEmail: string;
    evaluationDate: string;
    evaluationType: string;
    monitoringMethod: string;
    associateEmail: string;
    associateSite: string;
    supervisorEmail: string;
    contactId: string;
    formId: string;
    coachingStatus: CoachingStatus;
    deleted: boolean;
}

export interface QualitySubAttribute {
    subAttributeId: string;
    label: string;
    value: boolean;
}

export interface QualityQuestion {
    questionId: string;
    label: string;
    value: QualityQuestionValue;
    // For questions answered 'No', an array of sub-attributes must be provided.
    subAttributes: QualitySubAttribute[];
}

export interface BiQuestion {
    questionId: string;
    label: string;
    value: string;
    // subvalue is optional.
    subvalue?: string;
}

/**
 * The new CSQA payload (and what is stored in ES)
 */
export interface GetCsqaPayload {
    versionId: string;
    id: string;
    createdTimestamp: number;
    identifiers: CsqaIdentifiers;
    qualityQuestions: QualityQuestion[];
    biQuestions: BiQuestion[];
    notes: string;
}

export interface SearchCsqaPayload {
    id: string;
    createdTimestamp: number;
    evaluationDate: string;
    evaluatorEmail: string;
    evaluationType: string;
    monitoringMethod: string;
    associateEmail: string;
    supervisorEmail: string;
    contactId: string;
    formId: string;
    coachingStatus: string;
}

export interface ReviewFetchResponse {
    payload: SearchCsqaPayload[];
    maxResults?: boolean;
}

export interface HierarchyUser {
    Username: string;
    Site: string;
    Supervisor: string;
}

export type AgentData = HierarchyUser;
export type SupervisorData = HierarchyUser;

export interface UpdateReviewPayload {
    doc: GetCsqaPayload;
    id: string;
}

export interface FetchReviewsParams {
    startDate?: string;
    endDate?: string;
    associateEmailFilter?: string;
    supervisorEmailFilter?: string;
    evaluatorEmailFilter?: string;
    associateSiteFilter?: string;
    viewAll?: boolean;
}
